import { useDispatch, useSelector } from "react-redux";
import React, {useEffect, useState} from "react";
import RootState from "../../../redux/states/root.state";
import { fetchUserGroupPermissions } from "../../../redux/actions/userGroups.actions";
import { AppDispatch } from "../../../redux/store";
import { CircularProgress, Pagination, Button, TextField, Checkbox, FormControlLabel, List, ListItem, ListItemButton, ListItemText, ListItemIcon, Typography } from "@mui/material";

interface SelectProps {
    checked:any[];
    setChecked: any;
}

const MultiRemovePermissions: React.FC<SelectProps> = ({
    checked,
    setChecked
}) => {
const dispatch = useDispatch<AppDispatch>();
const {data:userGroup} = useSelector((state: RootState) => state.userGroup);
const {data:permissions, meta, loading} = useSelector((state: RootState) => state.permissions);
const [pageNumber, setPageNumber] = useState(1);
const [permissionName, setPermissionName] = useState(``);
const [permissionNameQuery, setPermissionNameQuery] = useState<any>(null);

useEffect(() => {
    if (userGroup) {
        let params = `page=${pageNumber}`;

        if (permissionNameQuery){
            params = params + `&name=${permissionNameQuery}`;
        }

        dispatch(fetchUserGroupPermissions({id:userGroup.id, params:params}));
    }
  }, [userGroup, pageNumber]);

const handleCheck = (permission:any) => {
    let newArr = [...checked];
    let found = checked?.find((perm:any)=>permission?.id===perm?.id)!==undefined;
    if(found){
      newArr = newArr.filter((perm:any)=>perm?.id!==permission?.id);
    } else {
      newArr.push(permission);
    }
    setChecked(newArr);
}

  return (
    <>
    <div className="user-search-container">
        <TextField type="search" placeholder="Search permission..." onChange={(e)=>setPermissionName(e.target.value)} size="small" fullWidth/>
        <Button type="button" variant="contained" onClick={()=>setPermissionNameQuery(permissionName)} size="small">Search</Button>
    </div>

    {loading ?
        <div className="no-users"><CircularProgress size={"24px"}/></div>
        :
    permissions.length>0 ? 
        <div className="select-container">   
            <List 
                dense
                sx={{
                    maxHeight: 200,
                    overflow: 'auto',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(0,0,0,0.1)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.5)',
                        },
                    },
                }}
            >
                {permissions.map((perm:any)=>(
                    <ListItem key={perm.id} disablePadding>
                        <ListItemButton
                            onClick={() => handleCheck(perm)}
                            selected={checked.some(c => c.id === perm.id)}
                            sx={{ borderRadius: 1 }}
                        >
                            <ListItemIcon>
                                <Checkbox 
                                    checked={checked.some(c => c.id === perm.id)}
                                    size="small"
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography variant="body2">
                                        {perm?.name !== '' ? `${perm?.name} (${perm?.id})` : perm?.id}
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Pagination 
                count={meta?.total_pages} 
                size="small"
                onChange={(e,page)=>setPageNumber(page)}
                page={pageNumber}
                showLastButton 
                showFirstButton 
                disabled={meta?.total_pages===1}
            />
        </div>
        :
        <div>No Permissions Found.</div>
    }
    </>
  );
};

export default MultiRemovePermissions;
